import { directory } from '@/api'
import {
	DIRECTORY_GET_STATUS,
	DIRECTORY_GET_ERROR,
	DIRECTORIES_GET,
	DIRECTORY_GET,
	DIRECTORY_CLEAR,
	GET_SUB_DIRECTORIES,
	DIRECTORIES_CLEAR,
} from '@/store/directory/types'

const getSubDirectories = async (ctx, query) => {
	ctx.commit(DIRECTORY_GET_STATUS, true)

	try {
		const { data, headers } = await directory.getSubDirectories(query)

		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(GET_SUB_DIRECTORIES, response)
		ctx.commit(DIRECTORY_GET_STATUS, false)
	} catch (e) {
		ctx.commit(DIRECTORY_GET_ERROR, e)
		ctx.commit(DIRECTORY_GET_STATUS, false)
		console.error(e)
	} finally {
		ctx.commit(DIRECTORY_GET_STATUS, false)
	}
}

const getDirectories = async (ctx, query) => {
	ctx.commit(DIRECTORY_GET_STATUS, true)

	try {
		const { data, headers } = await directory.getDirectories(query)

		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }

		ctx.commit(DIRECTORIES_GET, response)
		ctx.commit(DIRECTORY_GET_STATUS, false)
	} catch (e) {
		ctx.commit(DIRECTORY_GET_ERROR, e)
		ctx.commit(DIRECTORY_GET_STATUS, false)

		console.error(e)
	}
}

const getDirectory = async (ctx, directoryId) => {
	ctx.commit(DIRECTORY_GET_STATUS, true)

	try {
		const { data } = await directory.getDirectory(directoryId)

		ctx.commit(DIRECTORY_GET, data)
		ctx.commit(DIRECTORY_GET_STATUS, false)
	} catch (e) {
		ctx.commit(DIRECTORY_GET_ERROR, e)
		ctx.commit(DIRECTORY_GET_STATUS, false)

		console.error(e)
	}
}

const clearDirectory = async (ctx) => {
	try {
		ctx.commit(DIRECTORY_CLEAR)
	} catch (e) {
		ctx.commit(DIRECTORY_GET_ERROR, e)
	}
}

const clearDirectories = async (ctx) => {
	try {
		ctx.commit(DIRECTORIES_CLEAR)
	} catch (e) {
		ctx.commit(DIRECTORY_GET_ERROR, e)
	}
}

export default {
	getDirectory,
	getDirectories,
	clearDirectory,
	getSubDirectories,
	clearDirectories,
}
